import React, {useState} from 'react';
import MultipleSelector from '@/pages/datalab/components/MultipleSelector';

const LABEL = 'label'; // 一级类目
const SUB_LABEL = 'sub_label'; // 二级类目

function FilterSelectors(props) {
  const { labelOptions, subOptions, setFilterValue, isEn, label, subLabel } =
    props;

  const [valuesMap, setValuesMap] = useState<any>({
    [LABEL]: ['all'],
    [SUB_LABEL]: ['all'],
  });

  const applyFilterValueOnClose = (category: string, values: string[]) => {
    const next = values.length === 0 ? ['all'] : values;
    setValuesMap(prev => ({ ...prev, [category]: next }));
    setFilterValue(category, next[0] !== 'all' ? next : undefined);
  };

  const onChange = (category: string, value: string[]) => {
    let next = value;
    if (valuesMap[category].includes('all') && next.length > 1) {
      next = next.filter(item => item !== 'all');
    } else if (!valuesMap[category].includes('all') && next.includes('all')) {
      next = ['all'];
    }
    setValuesMap(prev => ({ ...prev, [category]: next }));
  };

  const onClose = (category: string) => {
    const current = valuesMap[category];
    if (current.length === 0) {
      applyFilterValueOnClose(category, ['all']);
      return;
    }
    applyFilterValueOnClose(category, current);
  };

  const buttonShow = (selectedOptions: { text?: string }[]) =>
    selectedOptions?.length > 2
      ? selectedOptions?.length
      : selectedOptions?.map(opt => opt?.text || '')?.join(',');

  return (
    <div className={'add-steep-filters'}>
      <MultipleSelector
        labelWidth={isEn ? 140 : 70}
        label={label}
        key={LABEL}
        options={labelOptions}
        onChange={value => {
          onChange(LABEL, value);
        }}
        value={valuesMap[LABEL]}
        onClose={() => onClose(LABEL)}
        button={buttonShow}
        searchable
      />
      <MultipleSelector
        labelWidth={isEn ? 140 : 70}
        label={subLabel}
        key={SUB_LABEL}
        options={subOptions}
        onClose={() => onClose(SUB_LABEL)}
        onChange={value => {
          onChange(SUB_LABEL, value);
        }}
        value={valuesMap[SUB_LABEL]}
        button={buttonShow}
        searchable
      />
    </div>
  );
}

export default FilterSelectors;
